export const colors = {
  grey: {
    _50: 'rgba(253, 253, 253, 1)',
    _100: 'rgba(248, 248, 248, 1)',
    _150: 'rgba(243, 243, 243, 1)',
    _200: 'rgba(233, 233, 233, 1)',
    _250: 'rgba(217, 217, 217, 1)',
    _300: 'rgba(212, 212, 212, 1)',
    _350: 'rgba(188, 193, 201, 1)',
    _400: 'rgba(185, 188, 200, 1)',
    _450: 'rgba(152, 156, 163, 1)',
    _500: 'rgba(158, 158, 158, 1)',
    _550: 'rgba(127, 131, 140, 1)',
    _600: 'rgba(96, 107, 128, 1)',
    _650: 'rgba(104, 108, 110, 1)',
    _700: 'rgba(102, 105, 108, 1)',
    _750: 'rgba(88, 88, 88, 1)',
    _800: 'rgba(71, 78, 85, 1)',
    _850: 'rgba(66, 68, 72, 1)',
    _900: 'rgba(56, 56, 56, 1)',
    _950: 'rgba(36, 36, 36, 1)',
    _1000: 'rgba(29, 28, 28, 1)',
  },
  red: {
    _50: 'rgba(250, 246, 246, 1)',
    _100: 'rgba(254, 236, 235, 1)',
    _150: 'rgba(255, 222, 220, 1)',
    _200: 'rgba(255, 209, 206, 1)',
    _250: 'rgba(248, 128, 120, 1)',
    _300: 'rgba(244, 67, 54, 1)',
    _350: 'rgba(214, 24, 10, 1)',
    _400: 'rgba(218, 30, 40, 1)',
    _450: 'rgba(176, 10, 0, 1)',
    _500: 'rgba(155, 66, 66, 1)',
    _550: 'rgba(77, 47, 47, 1)',
    _600: 'rgba(75, 62, 62, 1)',
  },
  green: {
    _50: 'rgba(237, 247, 237, 1)',
    _100: 'rgba(234, 251, 255, 1)',
    _200: 'rgba(223, 255, 225, 1)',
    _300: 'rgba(214, 255, 223, 1)',
    _350: 'rgba(186, 248, 188, 1)',
    _400: 'rgba(123, 198, 126, 1)',
    _450: 'rgba(76, 175, 80, 1)',
    _500: 'rgba(59, 135, 62, 1)',
    _550: 'rgba(30, 70, 32, 1)',
    _600: 'rgba(45, 101, 88, 1)',
    _700: 'rgba(45, 62, 46, 1)',
    _750: 'rgba(56, 122, 60, 1)',
  },
  blue: {
    _50: 'rgba(245, 248, 251, 1)',
    _100: 'rgba(234, 239, 244, 1)',
    _150: 'rgba(238, 247, 254, 1)',
    _200: 'rgba(240, 248, 255, 1)',
    _250: 'rgba(207, 220, 233, 1)',
    _300: 'rgba(189, 202, 212, 1)',
    _350: 'rgba(210, 233, 255, 1)',
    _400: 'rgba(208, 246, 255, 1)',
    _500: 'rgba(168, 221, 251, 1)',
    _550: 'rgba(144, 202, 249, 1)',
    _600: 'rgba(120, 189, 227, 1)',
    _650: 'rgba(91, 155, 252, 1)',
    _700: 'rgba(0, 98, 255, 1)',
    _750: 'rgba(0, 82, 215, 1)',
    _800: 'rgba(34, 102, 163, 1)',
    _850: 'rgba(3, 85, 104, 1)',
    _950: 'rgba(55, 58, 62, 1)',
    _1000: 'rgba(44, 48, 52, 1)',
  },
  white: {
    _100: 'rgba(255, 255, 255, 1)',
  },
  purple: {
    _50: 'rgba(188, 185, 200, 1)',
    _100: 'rgba(238, 229, 255, 1)',
    _150: 'rgba(186, 163, 232, 1)',
    _250: 'rgba(99, 76, 128, 1)',
    _300: 'rgba(88, 65, 117, 1)',
    _400: 'rgba(53, 0, 163, 1)',
  },
  orange: {
    _50: 'rgba(255, 245, 229, 1)',
    _100: 'rgba(255, 237, 215, 1)',
    _150: 'rgba(255, 232, 194, 1)',
    _250: 'rgba(237, 179, 94, 1)',
    _300: 'rgba(255, 181, 71, 1)',
    _350: 'rgba(255, 152, 0, 1)',
    _400: 'rgba(199, 119, 0, 1)',
    _450: 'rgba(152, 94, 5, 1)',
    _500: 'rgba(98, 97, 86, 1)',
    _550: 'rgba(102, 61, 0, 1)',
    _600: 'rgba(66, 54, 40, 1)',
  },
  black: {
    _50: 'rgba(51, 58, 64, 1)',
  },
  pink: {
    _50: 'rgba(255, 231, 255, 1)',
    _100: 'rgba(248, 188, 246, 1)',
    _300: 'rgba(166, 41, 176, 1)',
    _350: 'rgba(129, 49, 136, 1)',
  },
  transparent: {
    _50: 'rgba(255, 255, 255, 0.06)',
    _100: 'rgba(255, 255, 255, 0.2)',
    _150: 'rgba(160, 186, 211, 0.1)',
    _200: 'rgba(102, 125, 148, 0.1)',
    _250: 'rgba(127, 131, 140, 0.6)',
    _300: 'rgba(88, 88, 88, 0.9)',
    _350: 'rgba(51, 58, 64, 0.6)',
  },
  yellow: {
    _50: 'rgba(255, 245, 193, 1)',
    _250: 'rgba(133, 90, 5, 1 )',
  },
} as const;
